import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fira_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-fira-sans\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"firaSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fira_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-fira-mono\",\"weight\":[\"400\",\"500\",\"700\"]}],\"variableName\":\"firaMono\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/theme-light.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/theme-dark.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/xterm.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/code-mirror.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/audio-player.css");
